<template>
    <div class="modal">
        <div class="modal-title">{{ props.item.title }}</div>
        <a class="modal-close" @click="props.close"></a>
        <div v-if="initIsEmpty('init') || isEmpty('user')" class="modal-body">
            <button class="button-loader"></button>
        </div>
        <div v-else class="modal-body">
            <div v-html="props.item.text" class="modal-subtitle"></div>
            <div v-if="noBalance" class="modal-subtitle">
                {{ $t("balance.youPlayGame") }}
                {{ balanceShort }}
                {{ declineNouns(
                    balanceShort,
                    [
                        $t("balanceIn.zarik"),
                        $t("balanceIn.zarika"),
                        $t("balanceIn.zarikov")
                    ]
                ) }}.
                <span @click="$modal.show('balance-in')" class="link">
                    {{ $t("photos.replenishBalance") }}
                </span>
            </div>
        </div>

        <div class="modal-footer buttons-row">
            <button v-if="initIsEmpty('init') || isEmpty('user') || loader" class="button-loader"></button>
            <button v-else @click="accept" :disabled="noBalance" class="button">
                {{ $t("games.play") }}
            </button>
            <button @click="props.close" class="button-secondary">
                {{ $t("stories.cancel") }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { declineNouns } from '@/mixins/declineNouns';

export default {
    name: 'InviteOpener',
    props: {
        i18n: Object,
    },
    mixins: [
        declineNouns
    ],
    props: {
        props: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loader: false,
            balanceShort: 0,
            games: [
                'yes-no',
                'russian-roulette',
                'shell-game',
                'durak'
            ]
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/fetchUser',
            isEmpty: 'user/isEmpty',
            init: 'init/fetchInit',
            initIsEmpty: 'init/isEmpty'
        }),
        noBalance() {
            this.balanceShort = parseFloat(this.init.costs[
                'game_' + this.props.item.data.gameId + '_base_bet'
            ]) - parseFloat(this.user.balance);
            if (
                this.balanceShort > 0
            ) {

                return true;
            }
            return false;
        }
    },
    methods: {
        accept() {
            this.$router.push({
                name: 'game',
                params: {
                    id: this.props.item.data.gameId,
                    lobbyId: this.props.item.data.lobbyId
                }
            });
            this.props.close();;
        }
    }
}
</script>
